/* eslint-disable vue/no-reserved-keys */
<template lang="html">
  <div class="content-item" @click="goRedirectDetails">
    <img class="avater" v-if="isActual" v-lazy="`http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/%E7%A5%9E%E7%A7%98%E5%A4%B4%E5%83%8F.png?x-oss-process=image/resize,m_fill,w_72,h_72`" />
    <img class="avater" v-else v-lazy="`${user.avatar}?x-oss-process=image/resize,m_fill,w_72,h_72`" />
    <div class="content-item-body">
      <div class="content-item-body-header">
       <span v-if="!isActual" class="content-item-body-header-h2">{{user.nickName}}</span>
       <!-- <span v-if="curriculum && curriculum.type"  class="tag"># {{curriculum.type}}</span>
       <div v-else>
          <span v-for="tag of tags" :key="tag.id" class="tag"># {{tag.title}}</span>
       </div> -->
      </div>
      <span class="desc" v-html="content"></span>
      <div class="content-item-imgs">
        <img v-if="images.length === 1" class="maxImg" @click.stop="changeModel(0)"
          v-lazy="`${images[0].url}?x-oss-process=image/resize,m_lfit,w_392,h_392`" />
        <img v-else v-for="(img, index) of images" :class="{ singal: true, square: Object.is(images.length, 4) }"  @click.stop="changeModel(index)" :key="img.sort"
          v-lazy="`${img.url}?x-oss-process=image/resize,m_fill,w_184,h_184`" />
      </div>
      <div v-if="curriculum" class="curriculum" @click.stop="goCurriculumDetails(curriculum.id)">
        <img v-lazy="`${getHttpsImg(curriculum.cover)}?x-oss-process=image/resize,m_fill,w_240,h_134`"/>
        <div>
          <label class="curriculum-title">{{curriculum.title}}</label>
          <span class="studentCount">{{curriculum.students}} 人学习过</span>
        </div>
      </div>
      <div class="content-bottom">
        <div class="content-bottom-left">
          <h5>{{getShowTime(crateTime)}}</h5>
          <span v-if="(users && users.id === user.id)" class="delete" @click.stop="deleteMessage">删除</span>
        </div>
        <div class="menus">
          <ThumbUpItem  @click="goDetails">
            <img  src="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/message-grey.svg" />
            <span>{{commentCount ? commentCount : ''}}</span>
          </ThumbUpItem>
          <ThumbUpItem @click="thumbsUp" v-bind="getThumbUp" />
          <!-- <ThumbUpItem @click="setpOn" v-bind="getDown" /> -->
        </div>
      </div>
    </div>
    <ImgModel :imgs="modelSrc" :initialIndex="initialIndex" @click.native="changeModel" v-if="modelShow"/>
  </div>
</template>
<script>
import { post, _delete } from '../../../utils/request'
import { get, set, remove } from '../../../utils/token'
import { getBeforeTimeStr } from '../../../utils/date'
import ImgModel from '../../../components/ImgFile'
import ThumbUpItem from '../.../../../../components/thunmbUpItem'
import { Toast } from 'vant'
export default {
  components: {
    ImgModel,
    ThumbUpItem
  },
  props: {
    id: {
      // type: Number,
      default: 0
    },
    isActual: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object,
      default: () => {
        return {
          avatar: '',
          nickName: '',
          id: ''
        }
      }
    },
    crateTime: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    images: {
      type: Array,
      default: () => {
        return []
      }
    },
    commentCount: {
      type: Number,
      default: 0
    },
    upCount: {
      type: Number,
      default: 0
    },
    isUp: {
      type: Boolean,
      default: false
    },
    downCount: {
      type: Number,
      default: 0
    },
    isDown: {
      type: Boolean,
      default: false
    },
    curriculum: {
      type: Object,
      default: null
    },
    tags: {
      type: Array,
      default: () => {
        return [
        ]
      }
    }
  },
  data () {
    return {
      modelSrc: [],
      modelShow: false,
      initialIndex: 0,
      users: get('user')
    }
  },
  mounted () {
    this.scrollLocation()
  },
  methods: {
    getHttpsImg (url) {
      if (url.indexOf('https') === -1) {
        url = url.replace('http', 'https')
      }
      return url
    },
    deleteMessage () {
      const promise = _delete({
        url: `/diss/diss?id=${this.id}`
      })
      promise.then(res => {
        const { data: { message } } = res
        this.$emit('deleteMessage', this.id)
        Toast.success(message)
      })
    },
    scrollLocation () {
      this.$nextTick(() => {
        const scrollTop = get('makeComplaintsDetails')
        if (scrollTop && this.$refs.makeComplaints) {
          this.$refs.makeComplaints.scrollTop = scrollTop
          remove('makeComplaintsDetails')
        }
      })
    },
    changeModel (index = 0) {
      this.initialIndex = 0
      if (index) {
        this.initialIndex = index
      }
      this.modelShow = !this.modelShow
      if (this.modelShow) {
        this.modelSrc = this.images
      }
      // if (e) {
      //   e.preventDefault()
      //   e.stopPropagation()
      // }
    },
    getShowTime (time) {
      return getBeforeTimeStr(time)
    },
    goCreate () {
      const dynamic = this.$parent.$refs.dynamic
      if (dynamic) {
        set('makeComplaints', this.$parent.$refs.dynamic.scrollTop)
      }
      this.$router.push(`/exerland/makeComplaintsCreate?dissId=${this.id}`)
    },
    goCurriculumDetails (id) {
      this.$router.push(`/exerland/makeComplaintsDetails?id=${id}`)
    },
    setpOn (callback) {
      const promsie = post({
        url: `/diss/isDown/${this.id}/${get('user').id}`,
        data: {
          isDown: !this.isDown
        }
      })
      promsie.then(res => {
        const { status, data: { detail } } = res
        if (Object.is(status, 200)) {
          if (callback) {
            callback()
          }
          this.$emit('updateItem', detail)
        }
      }).catch(err => {
        if (callback) {
          callback()
        }
        throw new Error(err.message)
      })
    },
    thumbsUp (callback) {
      const promsie = post({
        url: `/diss/isUp/${this.id}/${get('user').id}`,
        data: {
          isUp: !this.isUp
        }
      })
      promsie.then(res => {
        const { status, data: { detail } } = res
        if (Object.is(status, 200)) {
          this.$emit('updateItem', detail)
          if (callback) {
            callback()
          }
        }
      }).catch(err => {
        if (callback) {
          callback()
        }
        throw new Error(err.message)
      })
    },
    goRedirectDetails () {
      this.$router.push(`/exerland/makeComplaintsDetails/${this.id}`)
    },
    goDetails () {
      const path = this.$route.path
      if (path.indexOf('makeComplaintsDetails') !== -1) {
        this.$router.push(`/exerland/makeComplaintsCreate?dissId=${this.id}`)
        return
      }
      if (this.commentCount) {
        this.$router.push(`/exerland/makeComplaintsDetails/${this.id}`)
      } else {
        this.$router.push(`/exerland/makeComplaintsCreate?dissId=${this.id}`)
      }
      this.$emit('click')
    }
  },
  computed: {
    getDown () {
      return {
        idProp: this.isDown,
        url: 'https://exerland-bbs.oss-cn-shanghai.aliyuncs.com/step-on-black.svg',
        url1: 'https://exerland-bbs.oss-cn-shanghai.aliyuncs.com/step-on-white.svg',
        count: this.downCount,
        label: ''
      }
    },
    getThumbUp () {
      return {
        idProp: this.isUp,
        url: 'http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/love-block.svg',
        url1: 'http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/love-grey.svg',
        count: this.upCount,
        label: ''
      }
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/ .customClass {
  width: 300px;
}
.content-item {
  padding: 23px 3.73vw 8px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #f5f5f5;
  .avater {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    margin-right: 16px;
  }
  .content-item-body {
    h5 {
      font-size: 14px;
      font-family: SFProText-Regular, SFProText;
      font-weight: 400;
      color: rgba(60, 60, 67, 0.6);
      line-height: 13px;
    }
    .content-item-body-header {
      display: flex;
      justify-content: space-between;
      .content-item-body-header-h2 {
        font-size: 16px;
        // font-family: SFProText-Semibold, SFProText;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        line-height: 21px;
        margin-bottom: 1px;
      }
      .tag {
        box-sizing: border-box;
        font-size:11px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(24,204,159,1);
        line-height: 20px;
        height:20px;
        background:rgba(236,253,249,1);
        border-radius:4px;
        box-sizing: border-box;
        display: inline-block;
        padding: 0 12px;
      }
    }
    .desc {
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 24px;
      width: 79.2vw;
      // text-overflow: ellipsis;
      // overflow: hidden;
      display: -webkit-box;
      // -webkit-line-clamp: 3;
      // -webkit-box-orient: vertical;
      margin-bottom: 10px;
    }
    .content-item-imgs {
      img {
        // max-width: 92px;
        // max-height: 92px;
        margin-right: 4px;
      }
      .maxImg {
        max-width: 196px;
        max-height: 196px;
      }
      .singal {
        max-width: 92px;
        max-height: 92px;
      }
      .square:nth-child(2n){
        margin-right: 30%;
      }
    }
    .curriculum {
      width: 100%;
      box-sizing: border-box;
      // height:92px;
      background:rgba(245,245,245,1);
      border-radius:5px;
      padding: 12px 13px;
      display: flex;
      img {
        width: 40.67%;
        height: calc(9 / 16 * 40.67%);
        margin-right: 10px;
      }
      div {
        display: flex;
        flex-direction: column;
        justify-content:space-between;
        .curriculum-title {
          font-size:13px;
          font-family:PingFangSC-Medium,PingFang SC;
          font-weight:500;
          color:rgba(51,51,51,1);
          line-height:18px;
        }
        .studentCount {
          font-size:9px;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
          color:rgba(136,136,136,1);
          line-height:13px;
        }
      }
    }
    .content-bottom {
      display: flex;
      height: 44px;
      justify-content: space-between;
      align-items: center;
      .content-bottom-left {
        display: flex;
        .delete {
          display: block;
          font-size:14px;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
          color:rgba(87,107,148,1);
          line-height:13px;
          margin-left: 16px;
        }
      }
      .menus {
        display: flex;
        justify-content: flex-start;
      }
    }
  }
}
</style>
